/* BCF PDP — length selector, qty stepper, gallery thumbs, related fetch.
   Mirrors the mockup PDP behavior (gram weight updates live). All lookups
   are defensive: missing elements are skipped. */
(function () {
  var galleryImageCache = {};

  function preloadGalleryImage(url) {
    if (!url) return Promise.reject(new Error('Missing gallery image URL'));
    if (galleryImageCache[url]) return galleryImageCache[url];
    galleryImageCache[url] = new Promise(function (resolve, reject) {
      var image = new Image();
      image.decoding = 'async';
      image.onload = function () {
        if (image.decode) image.decode().catch(function () {}).then(function () { resolve(image); });
        else resolve(image);
      };
      image.onerror = reject;
      image.src = url;
    });
    return galleryImageCache[url];
  }

  function swapGalleryImage(mainImage, button) {
    if (!mainImage || !button || !button.dataset.full) return;
    var full = button.dataset.full;
    var thumb = button.querySelector('img');
    mainImage.dataset.galleryTarget = full;
    if (button.dataset.alt) mainImage.alt = button.dataset.alt;
    if (thumb && (thumb.currentSrc || thumb.src)) mainImage.src = thumb.currentSrc || thumb.src;
    mainImage.classList.add('is-loading-gallery');
    preloadGalleryImage(full).then(function (image) {
      if (mainImage.dataset.galleryTarget !== full) return;
      mainImage.src = image.src;
      mainImage.classList.remove('is-loading-gallery');
    }).catch(function () {
      if (mainImage.dataset.galleryTarget === full) {
        mainImage.src = full;
        mainImage.classList.remove('is-loading-gallery');
      }
    });
  }

  window.BCFGalleryPreload = preloadGalleryImage;
  window.BCFGallerySwap = swapGalleryImage;

  function money(cents) {
    var d = cents / 100;
    var s = d.toFixed(2).replace(/\.00$/, '');
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function initPdp() {
    var root = document.querySelector('[data-bcf-pdp]');
    if (!root) return;

    /* ---------- gallery thumbs ---------- */
    var main = document.getElementById('pdp-main-img');
    var modelThumb = root.querySelector('.gal .thumbs button[data-gallery-kind="model"]');

    function showGalleryButton(button) {
      if (!button) return;
      root.querySelectorAll('.gal .thumbs button').forEach(function (x) { x.classList.remove('on'); });
      button.classList.add('on');
      var stage = main ? main.closest('.main') : null;
      if (stage) stage.classList.toggle('is-link-detail', button.dataset.galleryKind === 'detail');
      if (stage) stage.classList.toggle('is-fit-guide', button.dataset.galleryKind === 'fit');
      if (stage) stage.classList.toggle('is-whole-chain', button.dataset.galleryKind === 'whole');
      if (main && button.dataset.full) swapGalleryImage(main, button);
    }

    root.querySelectorAll('.gal .thumbs button[data-full]').forEach(function (b) {
      b.addEventListener('pointerdown', function () { preloadGalleryImage(b.dataset.full); }, { passive: true });
      b.addEventListener('pointerenter', function () { preloadGalleryImage(b.dataset.full); }, { passive: true });
      b.addEventListener('click', function () {
        showGalleryButton(b);
      });
    });

    /* ---------- gallery swipe ---------- */
    var galleryStage = main ? main.closest('.main') : null;
    var galleryThumbs = root.querySelector('.gal .thumbs');
    var swipeStart = null;

    function galleryButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('.gal .thumbs button[data-full]'));
    }

    function preloadGalleryNeighbors() {
      var buttons = galleryButtons();
      var active = root.querySelector('.gal .thumbs button.on[data-full]');
      var index = buttons.indexOf(active);
      if (index < 0) return;
      if (buttons[index - 1]) preloadGalleryImage(buttons[index - 1].dataset.full);
      if (buttons[index + 1]) preloadGalleryImage(buttons[index + 1].dataset.full);
    }

    function moveGallery(direction) {
      var buttons = galleryButtons();
      var active = root.querySelector('.gal .thumbs button.on[data-full]');
      var index = buttons.indexOf(active);
      if (index < 0) index = 0;
      var nextIndex = Math.max(0, Math.min(buttons.length - 1, index + direction));
      if (nextIndex === index || !buttons[nextIndex]) return;
      buttons[nextIndex].click();
      if (galleryThumbs && galleryThumbs.scrollWidth > galleryThumbs.clientWidth) {
        galleryThumbs.scrollTo({
          left: Math.max(0, buttons[nextIndex].offsetLeft - ((galleryThumbs.clientWidth - buttons[nextIndex].offsetWidth) / 2)),
          behavior: 'smooth'
        });
      }
      preloadGalleryNeighbors();
    }

    if (galleryStage && window.PointerEvent) {
      galleryStage.setAttribute('aria-roledescription', 'carousel');
      galleryStage.setAttribute('aria-label', 'Product image gallery. Swipe left or right to browse.');
      galleryStage.querySelectorAll('img').forEach(function (image) { image.draggable = false; });
      galleryStage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        swipeStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY
        };
        try { galleryStage.setPointerCapture(event.pointerId); } catch (e) {}
        preloadGalleryNeighbors();
      }, { passive: true });
      galleryStage.addEventListener('pointerup', function (event) {
        if (!swipeStart || event.pointerId !== swipeStart.id) return;
        var dx = event.clientX - swipeStart.x;
        var dy = event.clientY - swipeStart.y;
        swipeStart = null;
        try { galleryStage.releasePointerCapture(event.pointerId); } catch (e) {}
        if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        moveGallery(dx < 0 ? 1 : -1);
      }, { passive: true });
      galleryStage.addEventListener('pointercancel', function () { swipeStart = null; }, { passive: true });
    }

    var fitGalleryLink = root.querySelector('[data-open-fit-gallery]');
    var fitGalleryThumb = root.querySelector('.gal .thumbs button[data-gallery-kind="fit"]');
    if (fitGalleryLink && fitGalleryThumb) {
      fitGalleryLink.addEventListener('click', function () {
        showGalleryButton(fitGalleryThumb);
        var stage = main ? main.closest('.main') : null;
        if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var specDetails = document.querySelector('.specdetails');
    if (specDetails && window.matchMedia('(max-width: 680px)').matches) {
      specDetails.removeAttribute('open');
    }

    /* ---------- variant data ---------- */
    var variants = [];
    var dataEl = document.getElementById('bcf-variants');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }
    var form = document.getElementById('bcf-buy-form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var qty = 1;

    variants.forEach(function (variant) {
      var button = root.querySelector('.lens .len[data-id="' + variant.id + '"]');
      if (!button) return;
      button.disabled = !variant.available;
      var price = button.querySelector('.pr');
      if (price) price.textContent = variant.available ? variant.price : 'Sold out';
    });

    function current() {
      var id = idInput ? idInput.value : null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    function updateCartBtn() {
      var v = current();
      if (!v) return;
      setText('p-cart', money(v.cents * qty));
    }

    function updateLengthGuide(inches) {
      if (!inches) return;
      root.querySelectorAll('[data-guide-length]').forEach(function (label) {
        var selected = String(label.dataset.guideLength) === String(inches);
        label.classList.toggle('is-selected', selected);
        if (selected) label.setAttribute('aria-current', 'true');
        else label.removeAttribute('aria-current');
      });
      var selectedLabel = root.querySelector('[data-guide-selected]');
      if (selectedLabel) selectedLabel.textContent = inches + '″';
    }

    function apply(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      setText('p-price', v.price);
      setText('r-total', v.price);
      if (v.g) {
        setText('p-weight', v.g + ' g');
        setText('chip-g', v.g + ' g');
        setText('spec-g', v.g + ' g');
      }
      if (v.g && v.inches) setText('perm-g', v.g + ' g at ' + v.inches + '″');
      var lbl = document.getElementById('spec-g-label');
      if (lbl && v.inches) lbl.textContent = 'Weight (' + v.inches + '″)';
      var atc = form ? form.querySelector('[data-atc]') : null;
      if (atc) {
        atc.disabled = !v.available;
        if (v.available) atc.innerHTML = 'Add to cart · <span id="p-cart">' + money(v.cents * qty) + '</span>';
        else atc.textContent = 'Sold out';
      }
      if (v.model && modelThumb) {
        modelThumb.dataset.full = v.model;
        modelThumb.dataset.alt = v.modelAlt || ('Model wearing this chain at ' + v.inches + ' inches');
        var modelThumbImage = modelThumb.querySelector('img');
        if (modelThumbImage) modelThumbImage.src = v.model;
        showGalleryButton(modelThumb);
      }
      updateLengthGuide(v.inches);
      updateCartBtn();
      root.dispatchEvent(new CustomEvent('bcf:variant-change', { detail: { variant: v } }));
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    root.querySelectorAll('.lens .len').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.lens .len').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === b.dataset.id) { apply(variants[i]); return; }
        }
      });
    });
    var initialVariant = current();
    if (initialVariant) updateLengthGuide(initialVariant.inches);

    /* ---------- qty stepper ---------- */
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, qty + Number(b.dataset.qty));
        setText('qv', String(qty));
        if (qtyInput) qtyInput.value = String(qty);
        updateCartBtn();
        root.dispatchEvent(new CustomEvent('bcf:quantity-change', { detail: { quantity: qty } }));
      });
    });
  }

  /* ---------- related products (recommendations as backfill only) ---------- */
  function initRelated() {
    var el = document.querySelector('[data-bcf-related]');
    if (!el || !el.dataset.url) return;
    // The curated collection fallback renders server-side; only fetch ML
    // recommendations when the product belongs to no usable collection.
    if (el.querySelector('.card')) return;
    fetch(el.dataset.url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bcf-related]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          el.querySelectorAll('.rv').forEach(function (e) { e.classList.add('in'); });
        }
      })
      .catch(function () { /* fallback markup already rendered */ });
  }

  function init() { initPdp(); initRelated(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
